import axios from 'axios';

const baseUrl = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/';

///GET suggestions/api/4_1/rs/detectAddressByIp

function suggest(type, query, count = 5) {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl + type,
        {
          'query': query,
          'count': count,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Token 5a585e2ee3e58599595d913c1c702ddf232276db',
            //'X-Secret': import.meta.env.VITE_DADATA_SECRET_KEY,
          },
        }).then((r) => {
      if (r.status === 200) {
        resolve(r.data);
      } else {
        reject(false);
      }
    }).catch((err) => {
      console.error(err);
      reject(false);
    });

  });
}

export {suggest}
